import React, { memo } from "react";
import { Handle, Position, NodeProps } from "reactflow";
import Info from "../assets/icons/info.svg";

interface CustomNodeData {
  label: string;
  subtitle?: string;
  background: string;
  orientation?: "horizontal" | "vertical";
  isLabel?: boolean;
  onClick?: (id: string, data: CustomNodeData) => void;
  id?: string; // Added id to pass to onClick handler
}

const CustomNode = memo(
  ({ data, isConnectable, id }: NodeProps<CustomNodeData>) => {
    const {
      label,
      subtitle,
      background,
      orientation = "horizontal",
      isLabel = false,
    } = data;

    // Handle click event - don't trigger for section labels
    const handleNodeClick = () => {
      if (!isLabel && data.onClick) {
        // Pass the node id and data to the onClick handler
        data.onClick(id, { label, subtitle, background });
      }
    };

    if (isLabel) {
      // Section label styling
      return (
        <div
          style={{
            padding: "10px",
            width: orientation === "vertical" ? "40px" : "auto",
            height: orientation === "vertical" ? "120px" : "auto",
            borderRadius: "4px",
            background: "#0D0C2B",
            color: "#fff",
            border: "1px solid #666",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            writingMode:
              orientation === "vertical" ? "vertical-rl" : "horizontal-tb",
            textOrientation: orientation === "vertical" ? "mixed" : "upright",
            transform: orientation === "vertical" ? "rotate(180deg)" : "none",
          }}
        >
          <div style={{ fontWeight: "bold", fontSize: "12px" }}>{label}</div>
        </div>
      );
    }

    return (
      <div
        style={{
          padding: "10px",
          borderRadius: "4px",
          background,
          border: "1px solid #666",
          minWidth: "150px",
        }}
        className="relative"
      >
        <img
          src={Info}
          alt=""
          onClick={handleNodeClick}
          className="absolute top-0 h-4 cursor-pointer right-0"
        />
        <Handle
          type="target"
          position={Position.Top}
          style={{ background: "#555" }}
          isConnectable={isConnectable}
        />
        <div style={{ fontWeight: "bold" }}>{label}</div>
        {subtitle && (
          <div style={{ fontSize: "12px", marginTop: "5px" }}>{subtitle}</div>
        )}
        <Handle
          type="source"
          position={Position.Bottom}
          style={{ background: "#555" }}
          isConnectable={isConnectable}
        />
      </div>
    );
  }
);

export default CustomNode;
